module.exports = __webpack_public_path__ + "img/82ff28f.jpg";